import { useEffect } from "react";
import { useAuth } from "../provider/Authprovider";
import { useAppContext } from "../provider/AppContextProvider";
//import axios from "axios";
import { axiosHttp } from "../AxiosWrapper";
import { useNavigate } from "react-router-dom";
import { Modal } from 'antd';
import { Container } from "reactstrap";
import logo from "../assets/images/logos/logo.png";

const errorModal = () => {
    Modal.error({
       centered:true,
       width:520,
      title: 'Something went wrong!',
      content: 'We are working on getting this fixed as soon as we can. You may be able to try again.',
    });
};
//We'll be back. Sorry for the inconvinence. The website is under maintainance 
const underMaintenanceModal = () => {
    const styles = {
        logoImg:{
            display: "block",
            marginLeft: "auto",
            marginRight: "auto"
        },
        text:{
            fontSize:"medium",
            textAlign:"center",
            fontWeight:"500"
        }
    }
    Modal.info({
       centered:true,
       width:720,
       title: 'We\'ll be back!',
      content: 
      <div className="mt-3">
        <div><img style={styles.logoImg} width={75} height={75} alt="" src={logo}></img></div>
      <p className="mt-3" style={styles.text}>Sorry for the inconvinence. The website is under maintainance.</p>
      </div>
      
      ,
    });
};

const AxiosErrorHandler = ({ children }) => {
    const {login, unAuthorized, completeProfile, clearUser} = useAuth();
    const {toggleError} = useAppContext();
    const navigate = useNavigate();

    useEffect(() => {
        const responseInterceptor = axiosHttp.interceptors.response.use(response =>{ 
                return response
           
        }, (error) => {
            if (error.status === 401){//authentication
                 //login(null, true);//forceLogin
                 //login();
                 clearUser();
                 navigate("/");
            }else if(error.status === 403){//Authorization
                unAuthorized();
            }else if(error.status === 404){//No Found
                
            }else if(error.status === 423){//Profile not completed
                completeProfile();
            }else if("ERR_NETWORK" === error.code){
                //ignore error
            }else if(error.response && error.response.status === 503 ){//Service unavailable
                underMaintenanceModal();
            }else{
               // toggleError(true, error);// all other internal errors
               errorModal();
            }
            return Promise.reject(error)
        })

        return () => {
            axiosHttp.interceptors.response.eject(responseInterceptor);
        }
    }, [])

    return children
}
export default AxiosErrorHandler;



/*axiosHttp.interceptors.response.use(
        response => {
            return response
          },function (error) {
            if (error.status === 401){
                useAuth.login();
                
            }else if(error.status === 403){//Authorization
                useAuth.unAuthorized();
           }else if(error.status === 423){//Profile not completed
                window.location.href = '/dss/completeProfile';
            }
            else{
                errorModal();
            }
            return Promise.reject(error)
          }
    );*/

